import React,{FC,useState,useEffect,useRef} from 'react';
import {useNavigate,useLocation,HashRouter,Routes,Route,useParams} from 'react-router-dom';
import logo from './logo.svg';
import { useThrottleFn } from 'ahooks'
import { Button, NavBar, TabBar,SideBar,Toast,List } from 'antd-mobile'
import {
    AppOutline,
    MessageOutline,
    UnorderedListOutline,
    UserOutline,
    InformationCircleOutline
} from 'antd-mobile-icons'
import './App.css';
import './demo2.css'
import axios from 'axios';

const Bottom: FC = () => {
    const history = useNavigate()
    const location = useLocation()
    const { pathname } = location

    const setRouteActive = (value: string) => {
        history(value)
    }

    const tabs = [
        {
            key: '/',
            title: '伤寒杂病论',
            icon: <AppOutline />,
        },
        {
            key: '/prescription',
            title: '方剂',
            icon: <UnorderedListOutline />,
        },
        {
            key: '/medicine',
            title: '方症',
            icon: <MessageOutline />,
        },
        {
            key: '/diagnose',
            title: '百病不求人',
            icon: <UserOutline />,
        },
        {
            key: '/about',
            title: '关于',
            icon: <InformationCircleOutline />,
        },
    ]

    return (
        <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
            {tabs.map(item => (
                <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
            ))}
        </TabBar>
    )
}

export default  Bottom;